import { Breadcrumb } from '../types/breadcrumbs'
import { BreadcrumbsMutations } from '@/features/Breadcrumbs/model/state/mutations'
import { store } from '@/app/providers/store'

export const setBreadcrumbs = (breadcrumbs: Breadcrumb[]): void => {
	// используется store из app/providers/store тк useStore может возвращать undefined за пределами vue компонентов
	store.commit('breadcrumbs/' + BreadcrumbsMutations.SET_BREADCRUMBS, breadcrumbs)
}